import React from "react";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import AdminOrdersPage from "pages/AdminView/AdminOrdersPage/AdminOrdersPage";
import ClientOrdersPage from "pages/ClientView/ClientOrdersPage/ClientOrdersPage";
import RecruiterOrdersPage from "pages/RecruitersView/RecruiterOrdersPage/RecruiterOrdersPage";
import ErrorPage from "pages/ErrorPage/ErrorPage";

export default function OrdersSwitch() {
  const appContext = useAppContext();
  const { account } = appContext;
  const { accountType } = account;

  if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
    return <AdminOrdersPage />;
  } else if (accountType.type === ACCOUNT_TYPES.RECRUITER.type) {
    return <RecruiterOrdersPage />;
  } else if (accountType.type === ACCOUNT_TYPES.EMPLOYER_PRIVATE.type) {
    return <ClientOrdersPage />;
  } else {
    return <ErrorPage />;
  }
}
